module.exports = __webpack_public_path__ + "static/media/east.4547446d.png";